import { ApiPromise, useApi } from '../useApi.ts';

const staticApiCall = useApi('static');

function postFrontendEvent (message: string): ApiPromise<void> {
    return staticApiCall.post<unknown, void>({
        endpoint: '/frontendLog/logFrontendEvent',
        payload: { frontendEvent: message },
    });
}

export const frontendLogApi = {
    postFrontendEvent,
};
